/**
 *  Hud
 *
 *  Created by Legman on 29/03/2017.
 *
 */

import Common from "./Common";
import RaceLadder from "./RaceLadder";
import StartingLights from "./StartingLights";

/**
 * @class
 * @extends PIXI.Container
 */
export default class Hud extends PIXI.Container {
    constructor() {
        super();

        /**
         * @member {p3.Button}
         * @private
         */
        this._pauseButton = null;

        /**
         * @member {RaceLadder}
         * @private
         */
        this._ladder = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._laps = null;

        /**
         * @type {PIXI.BitmapText}
         * @private
         */
        this._lapsLabel = null;

        /**
         * @type {StartingLights}
         * @private
         */
        this._lights = null;

        this.on("added", this.init, this);
    }

    /**
     */
    init() {
        this.off("added", this.init);

        const assets = Common.assets;
        const states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_out");
        states.over = assets.getTexture("ui_btn_over");
        states.down = assets.getTexture("ui_btn_down");
        states.icon = assets.getTexture("ui_icon_pause");

        this._pauseButton = new p3.Button(states);
        this._pauseButton.overSoundName = "sfx_btn_rollover_00";
        this._pauseButton.clickSoundName = "sfx_btn_press_00";
        this.addChild(this._pauseButton);

        this._ladder = new RaceLadder();
        this.addChild(this._ladder);

        this._laps = new PIXI.Sprite(assets.getTexture("ui_icon_laps"));
        this._laps.x = Common.STAGE_WIDTH * 0.5 - 28;
        this._laps.y = 80;
        this._laps.anchor = new PIXI.Point(0.5, 0.5);
        this._laps.visible = false;
        this.addChild(this._laps);

        this._laps.label = new PIXI.BitmapText("99/99", font(42, "center"));
        this._laps.label.x = 28;
        this._laps.label.y = 2;
        this._laps.label.pivot.x = this._laps.label.textWidth * 0.5;
        this._laps.label.pivot.y = this._laps.label.textHeight * 0.5;
        this._laps.addChild(this._laps.label);
    }

    /**
     */
    resize() {
        this._pauseButton.x = (Common.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
        this._pauseButton.y = 100;

        this._ladder.x = (Common.STAGE_WIDTH - p3.View.width) * 0.5 + 120;
        this._ladder.y = 60;
    }

    /**
     */
    update() {
        this._ladder.update();
    }

    /**
     * @param {number} [delay]
     * @param {function} [callback]
     * @param {*} [scope]
     */
    runCountdown(delay, callback, scope) {
        this._lights = new StartingLights();
        this._lights.x = Common.STAGE_WIDTH * 0.5;
        this._lights.y = Common.STAGE_HEIGHT * 0.5 - 280;
        this.addChild(this._lights);

        this._lights.animateIn(function() {
            this._lights.start(delay, function() {
                callback && callback.call(scope);
                this._lights.animateOut(function() {
                    this._lights.destroy();

                    this._laps.alpha = 0;
                    TweenMax.to(this._laps, 0.4, {
                        alpha: 1,
                        ease: Power1.easeInOut,
                        onStart: function() {
                            this._laps.visible = true;
                        },
                        onStartScope: this
                    });
                }, this);
            }, this);
        }, this);
    }

    /**
     * @param lap
     * @param total
     */
    setLaps(lap, total) {
        this._laps.label.text = lap + "/" + total;
        this._laps.label.pivot.x = this._laps.label.textWidth * 0.5;
    }

    /**
     * @returns {p3.Button}
     */
    get pauseButton() {
        return this._pauseButton;
    }

    /**
     * @returns {RaceLadder}
     */
    get ladder() {
        return this._ladder;
    }

    /**
     * @returns {StartingLights}
     */
    get startingLights() {
        return this._lights;
    }
}
